export const permission = {
  itemsMenu: "items-menu",
  itemsRead: "items-read",
  itemsCreate: "items-create",
  itemsUpdate: "items-update",
  itemsDelete: "items-delete",
  itemsReport: "items-report",

  materialsMenu: "materials-menu",
  materialsRead: "materials-read",
  materialsCreate: "materials-create",
  materialsUpdate: "materials-update",
  materialsDelete: "materials-delete",
  materialsReport: "materials-report",

  categoriesMenu: "categories-menu",
  categoriesRead: "categories-read",
  categoriesCreate: "categories-create",
  categoriesUpdate: "categories-update",
  categoriesDelete: "categories-delete",
  categoriesReport: "categories-report",

  partiesMenu: "parties-menu",
  partiesRead: "parties-read",
  partiesCreate: "parties-create",
  partiesUpdate: "parties-update",
  partiesDelete: "parties-delete",
  partiesReport: "parties-report",
  partiesItems: "parties-items",

  paymentsRead: "payments-read",
  paymentsCreate: "payments-create",
  paymentsUpdate: "payments-update",
  paymentsDelete: "payments-delete",
  paymentsReport: "payments-report",

  materialOrdersMenu: "material-orders-menu",
  materialOrdersRead: "material-orders-read",
  materialOrdersCreate: "material-orders-create",
  materialOrdersUpdate: "material-orders-update",
  materialOrdersDelete: "material-orders-delete",
  materialOrdersReport: "material-orders-report",

  materialPurchasesMenu: "material-purchases-menu",
  materialPurchasesRead: "material-purchases-read",
  materialPurchasesCreate: "material-purchases-create",
  materialPurchasesUpdate: "material-purchases-update",
  materialPurchasesDelete: "material-purchases-delete",
  materialPurchasesReport: "material-purchases-report",
  materialPurchasesRate: "material-purchases-rate",

  materialStocksRead: "material-stocks-read",
  materialStocksCreate: "material-stocks-create",
  materialStocksUpdate: "material-stocks-update",
  materialStocksDelete: "material-stocks-delete",

  cuttingOrdersMenu: "cutting-orders-menu",
  cuttingOrdersRead: "cutting-orders-read",
  cuttingOrdersCreate: "cutting-orders-create",
  cuttingOrdersUpdate: "cutting-orders-update",
  cuttingOrdersDelete: "cutting-orders-delete",
  cuttingOrdersReport: "cutting-orders-report",

  cuttingReceivesMenu: "cutting-receives-menu",
  cuttingReceivesRead: "cutting-receives-read",
  cuttingReceivesCreate: "cutting-receives-create",
  cuttingReceivesUpdate: "cutting-receives-update",
  cuttingReceivesDelete: "cutting-receives-delete",
  cuttingReceivesReport: "cutting-receives-report",

  // Rates and amounts on every cutting screen (orders, receives), their lists and PDFs.
  cuttingRate: "cutting-rate",

  turningOrdersMenu: "turning-orders-menu",
  turningOrdersRead: "turning-orders-read",
  turningOrdersCreate: "turning-orders-create",
  turningOrdersUpdate: "turning-orders-update",
  turningOrdersDelete: "turning-orders-delete",
  turningOrdersReport: "turning-orders-report",

  turningReceivesMenu: "turning-receives-menu",
  turningReceivesRead: "turning-receives-read",
  turningReceivesCreate: "turning-receives-create",
  turningReceivesUpdate: "turning-receives-update",
  turningReceivesDelete: "turning-receives-delete",
  turningReceivesReport: "turning-receives-report",

  // Rates and amounts on every turning screen (orders, receives), their lists and PDFs.
  turningRate: "turning-rate",

  vmcOrdersMenu: "vmc-orders-menu",
  vmcOrdersRead: "vmc-orders-read",
  vmcOrdersCreate: "vmc-orders-create",
  vmcOrdersUpdate: "vmc-orders-update",
  vmcOrdersDelete: "vmc-orders-delete",
  vmcOrdersReport: "vmc-orders-report",

  vmcReceivesMenu: "vmc-receives-menu",
  vmcReceivesRead: "vmc-receives-read",
  vmcReceivesCreate: "vmc-receives-create",
  vmcReceivesUpdate: "vmc-receives-update",
  vmcReceivesDelete: "vmc-receives-delete",
  vmcReceivesReport: "vmc-receives-report",

  // Rates and amounts on every VMC screen (orders, receives), their lists and PDFs.
  vmcRate: "vmc-rate",

  employeesMenu: "employees-menu",
  employeesRead: "employees-read",
  employeesCreate: "employees-create",
  employeesUpdate: "employees-update",
  employeesDelete: "employees-delete",
  employeesReport: "employees-report",

  salariesRead: "salaries-read",
  salariesCreate: "salaries-create",
  salariesUpdate: "salaries-update",
  salariesDelete: "salaries-delete",
  salariesReport: "salaries-report",

  accountsMenu: "accounts-menu",
  accountsRead: "accounts-read",
  accountsCreate: "accounts-create",
  accountsUpdate: "accounts-update",
  accountsDelete: "accounts-delete",
  accountsReport: "accounts-report",

  accountTypesRead: "account-types-read",
  accountTypesCreate: "account-types-create",
  accountTypesUpdate: "account-types-update",
  accountTypesDelete: "account-types-delete",

  usersMenu: "users-menu",
  usersRead: "users-read",
  usersCreate: "users-create",
  usersUpdate: "users-update",
  usersDelete: "users-delete",
  usersPermission: "users-permission",

  activityLogsMenu: "activity-logs-menu",
  activityLogsRead: "activity-logs-read",

  businessReportsMenu: "business-reports-menu",
  businessReportsRead: "business-reports-read",
  businessReportsReport: "business-reports-report",

  settingsMenu: "settings-menu",
  settingsRead: "settings-read",
  settingsDeletePin: "settings-delete-pin",
  settingsAccessTime: "settings-access-time",
  settingsReportInfo: "settings-report-info",
  settingsRecordDays: "settings-record-days",
  settingsSizeUnit: "settings-size-unit",
};

// Modules switched off in the app: their dashboard cards, header links and
// routes stay hidden even when the user holds the permission. Remove a key
// here to bring the module back.
export const hiddenPermissionModules: string[] = [
  "employees",
  "salaries",
  "activity-logs",
  "business-reports",
];

// Single actions switched off inside a module that stays visible.
export const hiddenPermissions: string[] = [];

export const isHiddenPermission = (name: string): boolean =>
  hiddenPermissions.includes(name) ||
  permissionModules.some(
    (module) =>
      hiddenPermissionModules.includes(module.key) &&
      module.actions.some(
        (action) => permissionName(module.key, action) === name
      )
  );

export const hasPermission = (
  permissions: string[] | undefined,
  name: string
): boolean =>
  Array.isArray(permissions) &&
  permissions.includes(name) &&
  !isHiddenPermission(name);

export type PermissionModuleProps = {
  key: string;
  label: string;
  actions: string[];
};

export const permissionModules: PermissionModuleProps[] = [
  {
    key: "items",
    label: "આઈટમ્સ",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "materials",
    label: "મટીરીયલ",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "categories",
    label: "કેટેગરી",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "parties",
    label: "પાર્ટીઓ",
    actions: ["menu", "read", "create", "update", "delete", "report", "items"],
  },
  {
    key: "payments",
    label: "પાર્ટી એકાઉન્ટ",
    actions: ["read", "create", "update", "delete", "report"],
  },
  {
    key: "material-orders",
    label: "મટીરીયલ ઓર્ડર",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "material-purchases",
    label: "મટીરીયલ ખરીદી",
    actions: ["menu", "read", "create", "update", "delete", "report", "rate"],
  },
  {
    key: "material-stocks",
    label: "મટીરીયલ સ્ટોક",
    actions: ["read", "create", "update", "delete"],
  },
  {
    key: "cutting-orders",
    label: "કટીંગ ઓર્ડર",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "cutting-receives",
    label: "કટીંગ રિસીવ",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "cutting",
    label: "કટીંગ ભાવ",
    actions: ["rate"],
  },
  {
    key: "turning-orders",
    label: "ટર્નિંગ ઓર્ડર",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "turning-receives",
    label: "ટર્નિંગ રિસીવ",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "turning",
    label: "ટર્નિંગ ભાવ",
    actions: ["rate"],
  },
  {
    key: "vmc-orders",
    label: "VMC ઓર્ડર",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "vmc-receives",
    label: "VMC રિસીવ",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "vmc",
    label: "VMC ભાવ",
    actions: ["rate"],
  },
  {
    key: "employees",
    label: "કામદાર",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "salaries",
    label: "પગાર એકાઉન્ટ",
    actions: ["read", "create", "update", "delete", "report"],
  },
  {
    key: "accounts",
    label: "રોજમેળ",
    actions: ["menu", "read", "create", "update", "delete", "report"],
  },
  {
    key: "account-types",
    label: "રોજમેળ પાર્ટીઓ",
    actions: ["read", "create", "update", "delete"],
  },
  {
    key: "users",
    label: "યુઝર",
    actions: ["menu", "read", "create", "update", "delete", "permission"],
  },
  {
    key: "activity-logs",
    label: "એક્ટિવિટી લોગ",
    actions: ["menu", "read"],
  },
  {
    key: "business-reports",
    label: "બિઝનેસ રિપોર્ટ",
    actions: ["menu", "read", "report"],
  },
  {
    key: "settings",
    label: "સેટિંગ્સ",
    actions: [
      "menu",
      "read",
      "delete-pin",
      "access-time",
      "report-info",
      "record-days",
      "size-unit",
    ],
  },
];

export const permissionActionLabel: Record<string, string> = {
  menu: "મેનુ",
  read: "જોવું",
  create: "ઉમેરો",
  update: "સુધારો",
  delete: "કાઢી નાખો",
  report: "રિપોર્ટ",
  items: "ભાવ",
  rate: "રેટ",
  permission: "પરમિશન",
  "delete-pin": "ડિલીટ પિન",
  "access-time": "એક્સેસ ટાઈમ",
  "report-info": "રિપોર્ટ માહિતી",
  "record-days": "રેકોર્ડ દિવસ",
  "size-unit": "સાઈઝ યુનિટ",
};

export const permissionNote: Record<string, string> = {
  "items-menu": "ડેશબોર્ડ પર આઈટમ્સ કાર્ડ દેખાશે",
  "items-read": "આઈટમ્સનું લિસ્ટ અને વિગતો જોઈ શકશે",
  "items-create": "નવી આઈટમ ઉમેરી શકશે અને CSV/Excel ફાઇલ થી ઇમ્પોર્ટ કરી શકશે",
  "items-update": "આઈટમની વિગત સુધારી શકશે",
  "items-delete": "આઈટમ કાઢી નાખી શકશે",
  "items-report": "આઈટમ્સનું લિસ્ટ CSV/Excel માં એક્સપોર્ટ કરી શકશે",

  "materials-menu": "ડેશબોર્ડ પર મટીરીયલ કાર્ડ દેખાશે",
  "materials-read": "મટીરીયલનું લિસ્ટ જોઈ શકશે",
  "materials-create": "નવું મટીરીયલ ઉમેરી શકશે અને CSV/Excel ફાઇલ થી ઇમ્પોર્ટ કરી શકશે",
  "materials-update": "મટીરીયલની વિગત સુધારી શકશે",
  "materials-delete": "મટીરીયલ કાઢી નાખી શકશે",
  "materials-report": "મટીરીયલનું લિસ્ટ CSV/Excel માં એક્સપોર્ટ કરી શકશે",

  "categories-menu": "ડેશબોર્ડ પર કેટેગરી કાર્ડ દેખાશે",
  "categories-read": "કેટેગરીનું લિસ્ટ અને વિગતો જોઈ શકશે",
  "categories-create": "નવી કેટેગરી ઉમેરી શકશે અને CSV/Excel ફાઇલ થી ઇમ્પોર્ટ કરી શકશે",
  "categories-update": "કેટેગરીની વિગત સુધારી શકશે",
  "categories-delete": "કેટેગરી કાઢી નાખી શકશે",
  "categories-report": "કેટેગરીનું લિસ્ટ CSV/Excel માં એક્સપોર્ટ કરી શકશે",

  "parties-menu": "ડેશબોર્ડ પર પાર્ટીઓ કાર્ડ દેખાશે",
  "parties-read": "પાર્ટીઓનું લિસ્ટ અને પાર્ટીની વિગત જોઈ શકશે",
  "parties-create": "નવી પાર્ટી ઉમેરી શકશે અને CSV/Excel ફાઇલ થી ઇમ્પોર્ટ કરી શકશે",
  "parties-update": "પાર્ટીની વિગત સુધારી શકશે",
  "parties-delete": "પાર્ટી કાઢી નાખી શકશે",
  "parties-report": "પાર્ટીનો પેમેન્ટ રિપોર્ટ PDF બનાવી શકશે",
  "parties-items":
    "પાર્ટીના આઈટમ ભાવ (કટીંગ/ટર્નિંગ/VMC) જોઈ અને સેટ કરી શકશે — આ માટે આઈટમ્સનું જોવું પણ જરૂરી છે",

  "payments-read": "પાર્ટીનું એકાઉન્ટ (ઉધાર/જમા) જોઈ શકશે",
  "payments-create": "પાર્ટી એકાઉન્ટમાં પેમેન્ટ અને વધ-ઘટ એન્ટ્રી ઉમેરી શકશે",
  "payments-update": "પાર્ટી એકાઉન્ટની એન્ટ્રી સુધારી શકશે",
  "payments-delete": "પાર્ટી એકાઉન્ટની એન્ટ્રી કાઢી નાખી શકશે",
  "payments-report": "પાર્ટી એકાઉન્ટનો રિપોર્ટ PDF બનાવી શકશે",

  "material-orders-menu": "ડેશબોર્ડ પર મટીરીયલ ઓર્ડર બટન દેખાશે",
  "material-orders-read": "મટીરીયલ ઓર્ડરનું લિસ્ટ અને વિગત જોઈ શકશે",
  "material-orders-create": "નવો મટીરીયલ ઓર્ડર ઉમેરી શકશે",
  "material-orders-update": "મટીરીયલ ઓર્ડર સુધારી શકશે",
  "material-orders-delete": "ખરીદી વગરનો મટીરીયલ ઓર્ડર કાઢી નાખી શકશે",
  "material-orders-report": "મટીરીયલ ઓર્ડરનો રિપોર્ટ અને PDF બનાવી શકશે",

  "material-purchases-menu": "ડેશબોર્ડ પર મટીરીયલ ખરીદી બટન દેખાશે",
  "material-purchases-read": "મટીરીયલ ખરીદીનું લિસ્ટ અને વિગત જોઈ શકશે",
  "material-purchases-create":
    "નવી મટીરીયલ ખરીદી ઉમેરી શકશે — તેની રકમ પાર્ટી એકાઉન્ટમાં જમા થશે",
  "material-purchases-update": "મટીરીયલ ખરીદી સુધારી શકશે",
  "material-purchases-delete": "મટીરીયલ ખરીદી કાઢી નાખી શકશે",
  "material-purchases-report":
    "મટીરીયલ ખરીદીનો રિપોર્ટ અને PDF બનાવી શકશે — રેટ ની પરમિશન વગર PDF માં માત્ર જથ્થો દેખાશે",
  "material-purchases-rate":
    "મટીરીયલ ખરીદીમાં રેટ, પહેલાનો રેટ અને રકમ જોઈ, ઉમેરી અને સુધારી શકશે અને ખરીદીની સ્થિતિ (Pending/Complete) જોઈ શકશે — આ પરમિશન વગર ઉમેરેલ મટીરીયલ ₹0 સાથે સેવ થશે અને ખરીદી Pending રહેશે",

  "material-stocks-read":
    "મટીરીયલ લિસ્ટ માં દરેક મટીરીયલ ના સ્ટોક ના બાર અને દરેક મટીરીયલ નું સ્ટોક પેજ (ખરીદી, કટીંગ ઓર્ડર અને એન્ટ્રી નો ઇતિહાસ) જોઈ શકશે",
  "material-stocks-create":
    "મટીરીયલ લિસ્ટ અને સ્ટોક પેજ પર થી સ્ટોક વધ-ઘટ (શરૂઆત નો સ્ટોક, ગણતરી સુધારો કે નુકસાન) ની એન્ટ્રી ઉમેરી શકશે",
  "material-stocks-update": "સ્ટોક ની એન્ટ્રી સુધારી શકશે",
  "material-stocks-delete": "સ્ટોક ની એન્ટ્રી કાઢી નાખી શકશે",

  "cutting-orders-menu": "ડેશબોર્ડ પર કટીંગ ઓર્ડર બટન દેખાશે",
  "cutting-orders-read": "કટીંગ ઓર્ડરનું લિસ્ટ અને વિગત જોઈ શકશે",
  "cutting-orders-create":
    "નવો કટીંગ ઓર્ડર ઉમેરી શકશે — આઈટમ નો કટીંગ ભાવ ઓર્ડર માં સાચવાશે",
  "cutting-orders-update": "કટીંગ ઓર્ડર અને તેની સાથે મોકલેલ મટીરીયલ સુધારી શકશે",
  "cutting-orders-delete": "રિસીવ વગરનો કટીંગ ઓર્ડર કાઢી નાખી શકશે",
  "cutting-orders-report": "કટીંગ ઓર્ડરનો રિપોર્ટ અને PDF બનાવી શકશે",

  "cutting-receives-menu": "ડેશબોર્ડ પર કટીંગ રિસીવ બટન દેખાશે",
  "cutting-receives-read": "કટીંગ રિસીવનું લિસ્ટ અને વિગત જોઈ શકશે",
  "cutting-receives-create":
    "કટીંગ ઓર્ડર ની આઈટમ રિસીવ કરી શકશે — તેની રકમ પાર્ટી એકાઉન્ટમાં જમા થશે",
  "cutting-receives-update": "કટીંગ રિસીવ સુધારી શકશે",
  "cutting-receives-delete": "કટીંગ રિસીવ કાઢી નાખી શકશે",
  "cutting-receives-report": "કટીંગ રિસીવનો રિપોર્ટ અને PDF બનાવી શકશે",

  "cutting-rate":
    "કટીંગ ઓર્ડર અને રિસીવ માં ભાવ અને રકમ જોઈ શકશે (લિસ્ટ, વિગત અને PDF માં) — ભાવ આ પરમિશન વગર પણ આઈટમ કે પાર્ટી ના ભાવ માંથી આપમેળે લાગશે",

  "turning-orders-menu": "ડેશબોર્ડ પર ટર્નિંગ ઓર્ડર બટન દેખાશે",
  "turning-orders-read": "ટર્નિંગ ઓર્ડરનું લિસ્ટ અને વિગત જોઈ શકશે",
  "turning-orders-create":
    "કટીંગ તૈયાર આઈટમ નો નવો ટર્નિંગ ઓર્ડર ઉમેરી શકશે — આઈટમ નો ટર્નિંગ ભાવ ઓર્ડર માં સાચવાશે",
  "turning-orders-update": "ટર્નિંગ ઓર્ડર સુધારી શકશે",
  "turning-orders-delete": "રિસીવ વગરનો ટર્નિંગ ઓર્ડર કાઢી નાખી શકશે",
  "turning-orders-report": "ટર્નિંગ ઓર્ડરનો રિપોર્ટ અને PDF બનાવી શકશે",

  "turning-receives-menu": "ડેશબોર્ડ પર ટર્નિંગ રિસીવ બટન દેખાશે",
  "turning-receives-read": "ટર્નિંગ રિસીવનું લિસ્ટ અને વિગત જોઈ શકશે",
  "turning-receives-create":
    "ટર્નિંગ ઓર્ડર ની આઈટમ રિસીવ કરી શકશે — તેની રકમ પાર્ટી એકાઉન્ટમાં જમા થશે",
  "turning-receives-update": "ટર્નિંગ રિસીવ સુધારી શકશે",
  "turning-receives-delete": "ટર્નિંગ રિસીવ કાઢી નાખી શકશે",
  "turning-receives-report": "ટર્નિંગ રિસીવનો રિપોર્ટ અને PDF બનાવી શકશે",

  "turning-rate":
    "ટર્નિંગ ઓર્ડર અને રિસીવ માં ભાવ અને રકમ જોઈ શકશે (લિસ્ટ, વિગત અને PDF માં) — ભાવ આ પરમિશન વગર પણ આઈટમ કે પાર્ટી ના ભાવ માંથી આપમેળે લાગશે",

  "vmc-orders-menu": "ડેશબોર્ડ પર VMC ઓર્ડર બટન દેખાશે",
  "vmc-orders-read": "VMC ઓર્ડરનું લિસ્ટ અને વિગત જોઈ શકશે",
  "vmc-orders-create":
    "કટીંગ કે ટર્નિંગ તૈયાર આઈટમ નો નવો VMC ઓર્ડર ઉમેરી શકશે — આઈટમ નો VMC ભાવ ઓર્ડર માં સાચવાશે",
  "vmc-orders-update": "VMC ઓર્ડર સુધારી શકશે",
  "vmc-orders-delete": "રિસીવ વગરનો VMC ઓર્ડર કાઢી નાખી શકશે",
  "vmc-orders-report": "VMC ઓર્ડરનો રિપોર્ટ અને PDF બનાવી શકશે",

  "vmc-receives-menu": "ડેશબોર્ડ પર VMC રિસીવ બટન દેખાશે",
  "vmc-receives-read": "VMC રિસીવનું લિસ્ટ અને વિગત જોઈ શકશે",
  "vmc-receives-create":
    "VMC ઓર્ડર ની આઈટમ રિસીવ કરી શકશે — તેની રકમ પાર્ટી એકાઉન્ટમાં જમા થશે",
  "vmc-receives-update": "VMC રિસીવ સુધારી શકશે",
  "vmc-receives-delete": "VMC રિસીવ કાઢી નાખી શકશે",
  "vmc-receives-report": "VMC રિસીવનો રિપોર્ટ અને PDF બનાવી શકશે",

  "vmc-rate":
    "VMC ઓર્ડર અને રિસીવ માં ભાવ અને રકમ જોઈ શકશે (લિસ્ટ, વિગત અને PDF માં) — ભાવ આ પરમિશન વગર પણ આઈટમ કે પાર્ટી ના ભાવ માંથી આપમેળે લાગશે",

  "employees-menu": "ડેશબોર્ડ પર કામદાર કાર્ડ દેખાશે",
  "employees-read": "કામદારોનું લિસ્ટ અને વિગત જોઈ શકશે",
  "employees-create": "નવો કામદાર ઉમેરી શકશે",
  "employees-update": "કામદારની વિગત સુધારી શકશે અને હાજરી અપડેટ કરી શકશે",
  "employees-delete": "કામદાર કાઢી નાખી શકશે",
  "employees-report": "કામદારનો પગાર રિપોર્ટ PDF બનાવી શકશે",

  "salaries-read": "કામદારનું પગાર એકાઉન્ટ (બાકી પગાર અને ઉપાડ) જોઈ શકશે",
  "salaries-create": "પગાર અને ઉપાડની એન્ટ્રી ઉમેરી શકશે",
  "salaries-update": "પગાર એકાઉન્ટની એન્ટ્રી સુધારી શકશે",
  "salaries-delete": "પગાર એકાઉન્ટની એન્ટ્રી કાઢી નાખી શકશે",
  "salaries-report": "પગાર એકાઉન્ટનો રિપોર્ટ PDF બનાવી શકશે",

  "accounts-menu": "ડેશબોર્ડ પર રોજમેળ કાર્ડ દેખાશે",
  "accounts-read":
    "રોજમેળની આવક-જાવક જોઈ શકશે — આ માટે પાર્ટીઓ અને રોજમેળ પાર્ટીઓનું જોવું પણ જરૂરી છે",
  "accounts-create": "રોજમેળમાં આવક કે જાવકની એન્ટ્રી ઉમેરી શકશે",
  "accounts-update": "રોજમેળની એન્ટ્રી સુધારી શકશે",
  "accounts-delete": "રોજમેળની એન્ટ્રી કાઢી નાખી શકશે",
  "accounts-report": "રોજમેળનો રિપોર્ટ PDF બનાવી શકશે",

  "account-types-read": "રોજમેળની પાર્ટીઓનું લિસ્ટ જોઈ શકશે",
  "account-types-create": "રોજમેળમાં નવી પાર્ટી ઉમેરી શકશે",
  "account-types-update": "રોજમેળની પાર્ટીની વિગત સુધારી શકશે",
  "account-types-delete": "રોજમેળની પાર્ટી કાઢી નાખી શકશે",

  "users-menu": "ડેશબોર્ડ પર યુઝર કાર્ડ દેખાશે — માત્ર સુપર એડમીન",
  "users-read": "યુઝરોનું લિસ્ટ જોઈ શકશે — માત્ર સુપર એડમીન",
  "users-create": "નવો યુઝર ઉમેરી શકશે — માત્ર સુપર એડમીન",
  "users-update": "યુઝરની વિગત સુધારી શકશે — માત્ર સુપર એડમીન",
  "users-delete": "યુઝર કાઢી નાખી શકશે — માત્ર સુપર એડમીન",
  "users-permission": "બીજા યુઝરની પરમિશન બદલી શકશે — માત્ર સુપર એડમીન",

  "activity-logs-menu": "હેડરમાં એક્ટિવિટી લોગનું બટન દેખાશે — માત્ર સુપર એડમીન",
  "activity-logs-read": "એક્ટિવિટી લોગ જોઈ શકશે — માત્ર સુપર એડમીન",

  "business-reports-menu": "હેડરમાં બિઝનેસ રિપોર્ટનું બટન દેખાશે",
  "business-reports-read":
    "તારીખ પ્રમાણે આખા બિઝનેસનો રિપોર્ટ (પાર્ટી એકાઉન્ટ, રોજમેળ, પગાર) જોઈ શકશે — બધા મોડ્યુલના આંકડા દેખાશે",
  "business-reports-report": "બિઝનેસ રિપોર્ટની PDF બનાવી શકશે",

  "settings-menu": "પ્રોફાઇલ મેનુમાં સેટિંગ્સનું બટન દેખાશે",
  "settings-read": "સેટિંગ્સનું પેજ ખોલી શકશે",
  "settings-delete-pin": "ડિલીટ પિન ચાલુ/બંધ કરી શકશે અને પિન બદલી શકશે",
  "settings-access-time": "સિસ્ટમ વાપરવાનો સમય (એક્સેસ ટાઈમ) સેટ કરી શકશે",
  "settings-report-info":
    "PDF રિપોર્ટમાં છપાતું કંપની નામ, સરનામું અને લોગો બદલી શકશે",
  "settings-record-days":
    "Super Admin સિવાયના યુઝર્સને મટીરીયલ ઓર્ડર/ખરીદી, કટીંગ ઓર્ડર/રિસીવ, ટર્નિંગ ઓર્ડર/રિસીવ અને VMC ઓર્ડર/રિસીવના લિસ્ટમાં છેલ્લા કેટલા દિવસના રેકોર્ડ દેખાય તે સેટ કરી શકશે",
  "settings-size-unit":
    "મટીરીયલ સાઈઝ અને આઈટમ ની કટીંગ લંબાઈ પછી દેખાતો યુનિટ (mm, cm, m) બદલી શકશે — યુનિટ બદલવાથી સાચવેલ આંકડા બદલાતા નથી",
};

export const permissionRequires: Record<string, string[]> = {
  // The daybook shows the party filter only to users who can read parties.
  "accounts-read": ["parties-read", "account-types-read"],
  "parties-items": ["items-read"],
  // The item form loads its category and material dropdowns from those modules.
  "items-create": ["categories-read", "materials-read"],
  "items-update": ["categories-read", "materials-read"],
  // Export is a button on the module's list page.
  "items-report": ["items-read"],
  "materials-report": ["materials-read"],
  "categories-report": ["categories-read"],
  "business-reports-menu": ["business-reports-read"],
  "business-reports-report": ["business-reports-read"],
  // The order/purchase forms load their parties and materials through the module's read endpoints.
  "material-orders-create": ["material-orders-read"],
  "material-orders-update": ["material-orders-read"],
  "material-orders-delete": ["material-orders-read"],
  // The PDF button is on the order list.
  "material-orders-report": ["material-orders-read"],
  "material-purchases-create": ["material-purchases-read"],
  "material-purchases-update": ["material-purchases-read"],
  "material-purchases-delete": ["material-purchases-read"],
  "material-purchases-report": ["material-purchases-read"],
  "material-purchases-rate": ["material-purchases-read"],
  // The stock is shown on the materials list and its page is opened from there. Requirements aren't followed past one
  // step, so the entry permissions name the list too.
  "material-stocks-read": ["materials-read"],
  "material-stocks-create": ["material-stocks-read", "materials-read"],
  "material-stocks-update": ["material-stocks-read", "materials-read"],
  "material-stocks-delete": ["material-stocks-read", "materials-read"],
  // The order form loads its parties, items and the party's material through the order module's read endpoints.
  "cutting-orders-create": ["cutting-orders-read"],
  "cutting-orders-update": ["cutting-orders-read"],
  "cutting-orders-delete": ["cutting-orders-read"],
  "cutting-orders-report": ["cutting-orders-read"],
  "cutting-receives-create": ["cutting-receives-read"],
  "cutting-receives-update": ["cutting-receives-read"],
  "cutting-receives-delete": ["cutting-receives-read"],
  "cutting-receives-report": ["cutting-receives-read"],
  // The turning forms load their parties, items and cut pieces ready through the module's read endpoints.
  "turning-orders-create": ["turning-orders-read"],
  "turning-orders-update": ["turning-orders-read"],
  "turning-orders-delete": ["turning-orders-read"],
  "turning-orders-report": ["turning-orders-read"],
  "turning-receives-create": ["turning-receives-read"],
  "turning-receives-update": ["turning-receives-read"],
  "turning-receives-delete": ["turning-receives-read"],
  "turning-receives-report": ["turning-receives-read"],
  // The VMC forms load their parties, items and pieces ready through the module's read endpoints.
  "vmc-orders-create": ["vmc-orders-read"],
  "vmc-orders-update": ["vmc-orders-read"],
  "vmc-orders-delete": ["vmc-orders-read"],
  "vmc-orders-report": ["vmc-orders-read"],
  "vmc-receives-create": ["vmc-receives-read"],
  "vmc-receives-update": ["vmc-receives-read"],
  "vmc-receives-delete": ["vmc-receives-read"],
  "vmc-receives-report": ["vmc-receives-read"],
};

export const permissionName = (module: string, action: string): string =>
  `${module}-${action}`;
